export default "<button class=\"btn btn-primary\" ng-click=\"$ctrl.click()\">{{$ctrl.label}}</button>\n";